export default "__VITE_ASSET__CkmZKDbW__"